import CloseIcon from '@/components/svgs/Close'
import Logo from '@/components/svgs/Logo'
import { colors } from '@/constants/colors'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { HStack, VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Link, useRouter } from 'expo-router'
import { Platform, Pressable, View } from 'react-native'

const ReschedulePerioConfirmed = () => {
	const router = useRouter()

	return (
		<Screen className="bg-palette_1 flex-1" preset="fixed">
			<HStack className="pl-10 pr-4 lg:pt-2 web:pt-1 native:mt-[2.6rem] justify-between items-center">
				<View>
					<Logo />
				</View>
				<Link asChild href="../">
					<Pressable className="p-8">
						<CloseIcon
							color={colors.palette_6}
							height={Platform.OS === 'web' ? 16 : 18}
							width={Platform.OS === 'web' ? 16 : 18}
						/>
					</Pressable>
				</Link>
			</HStack>
			<VStack className="justify-center flex-1 items-center" gap={64}>
				<VStack className="justify-center items-center px-16" gap={32}>
					<Header className="text-center text-balance native:max-w-72" variant="h2">
						You're all set!
					</Header>
					<Text className="text-balance text-palette_6 text-center lg:max-w-96">
						Your Care Team will reach out to you shortly.
					</Text>
				</VStack>
				<Button onPress={() => router.replace('/')}>
					<ButtonText>Done</ButtonText>
				</Button>
			</VStack>
		</Screen>
	)
}

export { ReschedulePerioConfirmed }
